<template>
  <b-modal
    ref="modal-successful"
    id="modal-successful"
    centered
    hide-footer
    hide-header
  >
    <div class="px-3 py-5 text-center">
      <img src="@/assets/icon-success.png" alt="" width="120" height="120">
      <h4 class="text-bold mt-4">Successful</h4>
      <p class="text-muted mb-5">You have successfully {{ message }}</p>
      <b-button class="btn-custom px-4" variant="info" @click="onClickBack">
        Back
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    message: {
      types: String,
      default: () => 'nice'
    }
  },
  methods: {
    onClickBack() {
      this.$bvModal.hide('modal-successful')
    }
  }
}
</script>
